import { render, staticRenderFns } from "./OrganizationSubscriptionEdit.vue?vue&type=template&id=585b3326"
import script from "./OrganizationSubscriptionEdit.vue?vue&type=script&lang=js"
export * from "./OrganizationSubscriptionEdit.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSubscriptionEdit.vue?vue&type=style&index=0&id=585b3326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports